module.exports = __webpack_public_path__ + "img/face_shape_male_average_mask.c2004033.png";